import React from "react";

const spinnerStyle = `
@keyframes cw-spin {
  to { transform: rotate(360deg); }
}
.cw-spinner {
  width: 44px;
  height: 44px;
  border: 4px solid rgba(80, 180, 200, 0.25);
  border-top-color: #50B4C8;
  border-radius: 50%;
  animation: cw-spin 0.75s linear infinite;
}
`;

export default function LoadingOverlay({ show, message }) {
  if (!show) return null;
  return (
    <>
      <style>{spinnerStyle}</style>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(255,255,255,0.82)",
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "14px",
        }}
      >
        <div className="cw-spinner" />
        {message && (
          <span
            style={{
              fontSize: "0.95rem",
              fontWeight: 600,
              color: "#50B4C8",
              fontFamily: "'Rubik', sans-serif",
              letterSpacing: "0.01em",
            }}
          >
            {message}
          </span>
        )}
      </div>
    </>
  );
}
